import { useState } from "react";
import { Dialog } from "primereact/dialog";

export default function PPAddRuleGroupModal({ visible, close, onSave }) {
     const [groupName, setGroupName] = useState("");

     const handleSave = () => {
          if (groupName.trim()) {
               onSave(groupName.trim());
               setGroupName("");
               close();
          }
     };

     const handleClose = () => {
          setGroupName("");
          close();
     };

     return (
          <Dialog
               header="Neue Gruppe hinzufügen"
               visible={visible}
               style={{ width: '400px' }}
               onHide={handleClose}
               footer={
                    <div className="d-flex justify-content-end gap-2">
                         <button className="btn btn-secondary" onClick={handleClose}>
                              Abbrechen
                         </button>
                         <button 
                              className="btn btn-primary" 
                              onClick={handleSave}
                              disabled={!groupName.trim()}
                         >
                              Speichern
                         </button>
                    </div>
               }
          >
               <div className="mb-3">
                    <label htmlFor="groupNameInput" className="form-label fw-semibold">Gruppenname</label>
                    <input
                         type="text"
                         id="groupNameInput"
                         className="form-control"
                         value={groupName}
                         onChange={(e) => setGroupName(e.target.value)}
                         placeholder="Gruppenname eingeben"
                         onKeyDown={(e) => {
                              if (e.key === 'Enter' && groupName.trim()) {
                                   handleSave();
                              }
                         }}
                    />
               </div>
          </Dialog>
     );
}
